export enum MonitorType {
	None = 0,
	Ping,
	Port,
	SNMP,
	SNMP_Interface,
	CPU,
	Disk,
	DNS,
	WMI,
	HTTP,
	Maintenance,
	DeviceTracker,
	PRTG,
	VSAT,
	VHUB,
	Config,
	StalePort,
	Script
}
